module.exports = __webpack_public_path__ + "img/jihua.c7b92449.png";